import { render, staticRenderFns } from "./PesquisaEstiloVida.vue?vue&type=template&id=24338070&scoped=true"
import script from "./PesquisaEstiloVida.vue?vue&type=script&lang=js"
export * from "./PesquisaEstiloVida.vue?vue&type=script&lang=js"
import style0 from "./PesquisaEstiloVida.vue?vue&type=style&index=0&id=24338070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24338070",
  null
  
)

export default component.exports